module.exports = __webpack_public_path__ + "s/img/Fletching@2x.1fb6b8c2.png";